export const NEWLANG = 'NEWLANG';
export const DELETELANG = 'DELETELANG';
export const UPDATELANG = 'UPDATELANG';
export const LANGDATA = 'LANGDATA';
export const ONELANGDATA = 'ONELANGDATA';
export const SHOW_LOADING = 'SHOW_LOADING'